<template>
  <div class="week-by-car-num">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="wrapper">
      <div class="header">
        <el-form :inline="true" label-width="60px">
          <el-form-item label="统计周" label-width="75px">
            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>
          </el-form-item>
          <el-form-item label="" label-width="50px">
            <el-input  v-model="weekStarEnd" disabled placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="省市" label-width="75px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <el-cascader
                v-if="areaListPr.length>0"
                :options="areaListPr"
                v-model="formData.provCityCounty"
                :props="propsData()"
                clearable></el-cascader>
          </el-form-item>
          <el-form-item label="" label-width="75px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <el-input v-model="formData.phone" clearable placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="" label-width="75px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <el-input v-model="formData.devUser" clearable placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-button style="margin-left:30px;" @click="getData(true)">查询</el-button>
          <el-button style="margin-left:20px;" @click="onWeekDialogCommand">导出</el-button>
          <!--          <WeekDialog @on-command="onWeekDialogCommand" v-if="showWeekDialog"/>-->
        </el-form>
      </div>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight" stripe style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="50" fixed="left"/>
        <el-table-column prop="provinceName" label="省" align="center"></el-table-column>
        <el-table-column prop="cityName" label="市" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="devUser" label="用户名" align="center"></el-table-column>
        <el-table-column prop="receiveCustomerNum" label="领取客户数" align="center"></el-table-column>
        <el-table-column prop="unsubscribeNum" label="退订客户数" align="center"></el-table-column>
        <el-table-column prop="devDuringNum" label="开发中客户数" align="center"></el-table-column>
        <el-table-column prop="devFinishNum" label="已开发客户数" align="center"></el-table-column>
        <el-table-column prop="devStopNum" label="终止开发客户数" align="center"></el-table-column>
        <el-table-column prop="successRate" label="开发成功率" align="center"></el-table-column>
      </el-table>
      <div class="pageBlock">
        <el-pagination @current-change="onChangePage" :current-page.sync="index" :page-size="pageSize"
                       layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
// import areaList from './components/areaList'

import WeekPopover from '../components/weekPopover.vue'
import WeekDialog from '../components/weekDialog.vue'
import Util from '@/utils/util'
import {collectAnalysisPage, collectAnalysisEx} from "@/api/log";
import http from '@/api/freight' // 请求汇总
import Cookies from "js-cookie";

export default {
  name: 'week-by-car-num',
  components: {WeekPopover, WeekDialog},
  data() {
    return {
      showWeekDialog: false,
      mark: false, //遮罩层开关
      weekStarEnd: '', //遮罩层开关
      progressNum: 0, //下载进度条进度
      formData: {
        phone:'',
        devUser:'',
        provCityCounty:[],
      },
      areaListPr: [],
      selectDate: '',
      selectDateVal: [],
      pickerOptions: {
        onPick: ({maxDate, minDate}) => {
          this.selectDate = minDate.getTime()
          if (maxDate) {
            this.selectDate = ''
          }
        },
        disabledDate: (time) => {
          if (time.getTime() >= new Date().getTime()) {
            return true // 禁用该日期 今天之后的时间不可选
          }
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.selectDate - one
            const maxTime = this.selectDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      tableCol: [
        {
          name: '运营车辆数',
          children: [
            {name: '全部车辆', prop: 'runCarNum0'},
            {name: '柴油车辆', prop: 'runCarNum1'},
            {name: 'LNG车辆', prop: 'runCarNum2'},
            {name: '新能源车辆', prop: 'runCarNum3'},
          ],
        },
        {
          name: '运营里程',
          children: [
            {name: '全部车辆', prop: 'totalMile0'},
            {name: '柴油车辆', prop: 'totalMile1'},
            {name: 'LNG车辆', prop: 'totalMile2'},
            {name: '新能源车辆', prop: 'totalMile3'},
          ],
        },
      ],

      curDate: '',

      tableData: [],

      total: 0, // 总页数
      index: 1, // 当前页数
      pageSize: 20,
    }
  },
  computed: {
    areaList() {
      let nerArr = JSON.parse(JSON.stringify(this.$store.getters.areaList))
      if (nerArr.length > 0) {
        nerArr.forEach(item => {
          item.provinceCode = item.provinceCode + '0000'
        })
      }
      return nerArr
    },
  },
  mounted() {
    const start = new Date();
    start.setDate(1);
    start.setHours(0, 0, 0, 0);
    const end = new Date();
    const day = end.getDate();
    if (day > 30) {
      end.setDate(30);
    }
    const begin = Util.format(new Date(start).getTime(), "yyyy-MM-dd hh:mm:ss")
    const endVal = Util.format(end.getTime(), "yyyy-MM-dd hh:mm:ss")
    this.selectDateVal = [begin, endVal]
    // this.getData()
    this.getPrInter()
  },
  methods: {
    async getPrInter() {
      const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      this.areaListPr = data
          .map(item => ({
            value: item.code,
            label: item.name,
            leaf: false
          }));
      if (this.areaListPr.length == 1) {
        this.cardNum = Util.keyValueCardNum[this.areaListPr[0].value.substring(0, 2)]
      }
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    propsData() {
      const vm = this
      return {
        lazy: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          }else {
            resolve([])
          }
        }
      }
    },
    onChangePage(index) {
      this.index = index
      this.getData()
    },
    getData(flag) {
      if (flag) {
        this.index = 1
      }
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      if (!curSelectedWeek) {
        this.$message({
          message: '请选择周',
          type: 'warning',
        })
        return
      }
      collectAnalysisPage({
        ...this.formData,
        ...curSelectedWeek,
        provinceCode: this.formData.provCityCounty[0] || '',
        cityCode: this.formData.provCityCounty[1] || '',
        pageNum: this.index,
        pageSize: this.pageSize,
      })
          .then((e) => {
            if (200 != e.code) {
              this.$message({
                message: e.message || '数据获取出错',
                type: 'error',
              })
              return
            }
            let typeText = {
              0: '石化总部', 1: '石化省市公司', 2: '石化地市(片区)公司', 3: '中交兴路'
            }
            e.data.dataList.forEach(item => {
              item.cityName = item.cityName?item.cityName:'-'
            })
            this.tableData = e.data.dataList
            this.index = e.data.pageNum
            this.total = e.data.total
            if(flag){
              if(this.tableData.length > 0){
                this.weekStarEnd = '(' + this.tableData[0].weekStart + '-' + this.tableData[0].weekEnd + ')'
              }else{
                this.weekStarEnd = '';
              }
            }
          })
          .catch((err) => {
            console.error(err)
            this.curDate = ''
          })
    },

    onWeekPopOverCommand(params) {
      switch (params.type) {
        case 'default-week':
          this.getData(true)
          break
        default:
          break
      }
    },

    onWeekDialogCommand() {
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      if (!curSelectedWeek) {
        this.$message({
          message: '请选择周',
          type: 'warning',
        })
        return
      }
      window.location.assign(collectAnalysisEx({
        ...this.formData,
        ...curSelectedWeek,
        provinceCode: this.formData.provCityCounty[0] || '',
        cityCode: this.formData.provCityCounty[1] || '',
      }))
    },
  },
}
</script>

<style lang="stylus" scoped>
.wrapper {
  padding: 20px;
  background: #fff;

  .header {
    margin-bottom: 20px;
  }
}

.pageBlock {
  display: flex;
  margin-top: 20px;
}
</style>
